import { toDate, intervalToDuration, subMinutes } from 'date-fns';

const getCountdown = (activityStartTimestamp: number, waitingRoomOffsetMinutes: number) => {
    const now = new Date();
    const activityStart = toDate(activityStartTimestamp);
    let finished = false;

    let minutes = 0;
    let seconds = 0;
    let hours = null;

    const waitingRoomStart = subMinutes(activityStartTimestamp, waitingRoomOffsetMinutes);
    const isWaitingRoomActivated = now.getTime() > waitingRoomStart.getTime();

    if (activityStartTimestamp && waitingRoomOffsetMinutes) {
        if (now.getTime() < activityStartTimestamp) {
            const interval = intervalToDuration({ start: now, end: activityStart });

            minutes = interval.minutes;
            seconds = interval.seconds;
            hours = interval.hours;
        } else {
            finished = true;
        }
    }

    const zeroM = minutes < 10 ? 0 : '';
    const zeroS = seconds < 10 ? 0 : '';

    const started =
        !!(hours !== null && hours < 1 && minutes < waitingRoomOffsetMinutes) || finished;

    return {
        formattedCountdown: `${zeroM}${minutes}:${zeroS}${seconds}`,
        started: started && isWaitingRoomActivated,
        finished,
    };
};

export default getCountdown;
